module.exports = __webpack_public_path__ + "img/sdg_pt-pt_(15).0596f93d.png";